import { cn } from '../../lib/utils';

interface FormInputProps {
  label: string;
  name: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  icon?: React.ReactNode;
  placeholder?: string;
  required?: boolean;
  className?: string;
  error?: string;
}

export function FormInput({
  label,
  name,
  type = 'text',
  value,
  onChange,
  icon,
  placeholder,
  required = true,
  className,
  error
}: FormInputProps) {
  return (
    <div className={cn('relative', className)}>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 pointer-events-none">
            {icon}
          </div>
        )}
        
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className={cn(
            'block w-full px-4 py-3 rounded-xl border transition-all duration-200',
            'bg-white/50 backdrop-blur-sm',
            icon && 'pl-10',
            error 
              ? 'border-red-300 focus:border-red-500 focus:ring-2 focus:ring-red-500/20'
              : 'border-gray-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20',
            'placeholder-gray-400 text-gray-900'
          )}
        />
      </div>
      
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}